import { render, staticRenderFns } from "./ItemTypesList.vue?vue&type=template&id=3b969cd2"
import script from "./ItemTypesList.vue?vue&type=script&lang=js"
export * from "./ItemTypesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports